const COLORS = {
  primary: "#FD5154",
  primaryDark: "#E4383B",
  primaryLight: "#FF6B6E",
  darkGray: "#26303E",
  mediumGray: "#566373",
  mediumLightGray: "#7b8592",
  lightGray: "#C5C9D1",
  lighterGray: "#E1E6E9",
  lightestGray: "#FAFAFA",
  white: "#FFFFFF",
  black: "#000000",
  green: "#2DC878",
  errorRed: "#EC5252",
  highlightBlue: "rgba(74, 144, 226, 0.10)",
  highlightYellow: "#FEF9C3",
  notificationSuccess: "#CCF4E3",
  notificationConfirmation: "#FDEECD",
  notificationError: "#FBDCDC",
  notificationInfo: "#D6E5F3"
};

export const LW_COLORS = {
  white: "#fff",
  black: "#000",
  helix: {
    "brand": "#236847",
    "dark-green": "#233d2d",
    "light-green": "#488563",
    "mint-green": "#b7dbb6",
    "white-green": "#e5ede7",
    "sec-orange": "#f15423",
    "sec-light-orange": "#f8baa7",
    "sec-white-orange": "#fdede9",
    "sec-blue": "#3e6fdf",
    "sec-light-blue": "#a6cdf4",
    "sec-white-blue": "#f1f5ff"
  },
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827"
  },
  red: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#991B1B",
    900: "#7F1D1D"
  }
};

export default COLORS;
